var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66602 0.666504V2.6665H7.33268V0.666504H8.66602Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28516 2.343L4.69937 3.75721L3.75656 4.70002L2.34235 3.28581L3.28516 2.343Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6557 3.28581L12.2415 4.70002L11.2987 3.75721L12.7129 2.343L13.6557 3.28581Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99935 7.99984C3.99935 5.7907 5.79021 3.99984 7.99935 3.99984C10.2085 3.99984 11.9993 5.7907 11.9993 7.99984C11.9993 10.209 10.2085 11.9998 7.99935 11.9998C5.79021 11.9998 3.99935 10.209 3.99935 7.99984ZM7.99935 5.33317C6.52659 5.33317 5.33268 6.52708 5.33268 7.99984C5.33268 9.4726 6.52659 10.6665 7.99935 10.6665C9.47211 10.6665 10.666 9.4726 10.666 7.99984C10.666 6.52708 9.47211 5.33317 7.99935 5.33317Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666016 7.33317H2.66602V8.6665H0.666016V7.33317Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 7.33317H15.3327V8.6665H13.3327V7.33317Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69932 12.2425L3.28511 13.6567L2.3423 12.7139L3.75651 11.2997L4.69932 12.2425Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2415 11.2997L13.6558 12.7139L12.7129 13.6567L11.2987 12.2425L12.2415 11.2997Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66602 13.3332V15.3332H7.33268V13.3332H8.66602Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.5b037eacee67f0214bd00088e0ddff54.svg";
export { ForwardRef as ReactComponent };